import { render, staticRenderFns } from "./ProLinksBox.vue?vue&type=template&id=ff494eea&scoped=true&"
import script from "./ProLinksBox.vue?vue&type=script&lang=js&"
export * from "./ProLinksBox.vue?vue&type=script&lang=js&"
import style0 from "./ProLinksBox.vue?vue&type=style&index=0&id=ff494eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff494eea",
  null
  
)

export default component.exports